{
  "name": "dietrans-frontend",
  "version": "1.0.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:deploy": "ng build && npm run sentry:sourcemaps",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org dietrans --project dietrans-frontend ./dist && sentry-cli sourcemaps upload --org dietrans --project dietrans-frontend ./dist && ngsw-config ./dist/dietrans-frontend/browser ./ngsw-config.json",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "local_dev": "ng serve",
    "lan_dev": "ng serve -c lan_dev --host 0.0.0.0 --disable-host-check",
    "pwa_dev": "ng build && npx http-server dist/dietrans-frontend/browser -p 4200 -c-1 -P \"http://127.0.0.1:4200?\"",
    "lint": "eslint \"src/**/*.ts\"",
    "lint:fix": "eslint \"src/**/*.ts\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,css,json}\""
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.11.0",
  "dependencies": {
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/service-worker": "^21.2.18",
    "@lucide/angular": "^1.23.0",
    "@sentry/angular": "^10.69.0",
    "chart.js": "^4.5.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.0",
    "@sentry/cli": "^2.58.6",
    "@tailwindcss/postcss": "^4.3.2",
    "@typescript-eslint/eslint-plugin": "^8.66.0",
    "@typescript-eslint/parser": "^8.66.0",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "http-server": "^14.1.1",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.17",
    "prettier": "^3.9.6",
    "tailwindcss": "^4.3.2",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
